module.exports = __webpack_public_path__ + "img/志愿者活动.f49950d9.png";